module.exports = __webpack_public_path__ + "static/img/anasayfa2.ab36c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anasayfa2.png
// module id = r/gl
// module chunks = 1